import { useState } from "react";
import { useNavigate, useRevalidator } from "react-router-dom";
import { FullWidthLine } from "../../../shared";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const CoverageYearPart = () => {
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const { yearsForZip } = useZipRootLoaderData();
  const [activeYear, setActiveYear] = useState<number | null>(null);

  const Continue = (e: React.MouseEvent<Element, MouseEvent>) => {
    if (activeYear) {
      sessionStorage.setItem("planYear", activeYear.toString());
      revalidator.revalidate();
      navigate("/get-recommendations/coverage");
    }
  };

  return (
    <div className="grid-container">
      <div
        className="hide-for-small-only"
        style={{ paddingLeft: 100, paddingRight: 100, paddingBottom: 100 }}
      >
        <h3
          style={{
            fontSize: 39,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
            paddingTop: 56,
            paddingBottom: 32,
          }}
        >
          Coverage
        </h3>
        <div className="grid-x">
          <div className="cell small-12 medium-8" style={{ paddingRight: 10 }}>
            <h4
              style={{
                fontSize: 25,
                fontWeight: 400,
                lineHeight: "32px",
                color: "#212126",
                fontFamily: "franklin-gothic-urw,sans-serif",
              }}
            >
              Which coverage year are you looking for?*
            </h4>
            <div style={{ color: "#212126", fontSize: 18 }}>*Required</div>
          </div>
          <div
            className="cell small-12 medium-4"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {yearsForZip.map((year, index) => (
              <button
                type="button"
                key={index}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.preventDefault();
                  setActiveYear(year.Year);
                }}
                style={{
                  marginRight: 24,
                  boxShadow:
                    "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
                  backgroundColor: activeYear === year.Year ? "#1B54C2" : "",
                  color: activeYear === year.Year ? "white" : "",
                  border: "1px solid #1B54C2",
                  borderColor: activeYear === year.Year ? "#1B54C2" : "#D3E1F0",
                  flex: 1,
                }}
                className="button hollow"
              >
                {year.Year}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="show-for-small-only">
        <h3
          style={{
            fontSize: 30,
            fontWeight: 600,
            lineHeight: "36px",
            textTransform: "uppercase",
            color: "#003A5D",
            paddingTop: 48,
            paddingBottom: 16,
          }}
        >
          Coverage
        </h3>
        <div className="grid-x" style={{ paddingTop: 24, paddingBottom: 64 }}>
          <div className="cell small-12 medium-8" style={{ paddingRight: 10 }}>
            <h4
              style={{
                color: "#212126",
                fontSize: 22,
                fontWeight: 500,
                lineHeight: "27px",
              }}
            >
              Which coverage year are you looking for?*
            </h4>
            <div
              style={{ color: "#212126", paddingBottom: 16, paddingTop: 16 }}
            >
              *Required
            </div>
          </div>
          <div
            className="cell small-12 medium-4"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {yearsForZip.map((year, index) => (
              <button
                type="button"
                key={index}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.preventDefault();
                  setActiveYear(year.Year);
                }}
                style={{
                  marginRight: 24,
                  boxShadow:
                    "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
                  backgroundColor: activeYear === year.Year ? "#1B54C2" : "",
                  color: activeYear === year.Year ? "white" : "",
                  border: "1px solid #1B54C2",
                  borderColor: activeYear === year.Year ? "#1B54C2" : "#D3E1F0",
                  flex: 1,
                }}
                className="button hollow"
              >
                {year.Year}
              </button>
            ))}
          </div>
        </div>
      </div>
      <FullWidthLine />
      <div
        className="show-for-small-only"
        style={{
          display: "flex",
          paddingTop: 24,
          paddingBottom: 40,
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          type="button"
          disabled={activeYear === null}
          style={{
            backgroundColor: activeYear === null ? "#CACACA" : "",
            width: "100%",
          }}
          className="button"
          onClick={Continue}
        >
          Continue
        </button>
      </div>
      <div
        className="hide-for-small-only"
        style={{
          display: "flex",
          paddingTop: 24,
          justifyContent: "flex-end",
          paddingBottom: 24,
        }}
      >
        <button
          type="button"
          disabled={activeYear === null}
          style={{ backgroundColor: activeYear === null ? "#CACACA" : "" }}
          className="button"
          onClick={Continue}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default CoverageYearPart;
